import { useViewModel } from '@descomplica/microfrontend-react';
import { observer } from 'mobx-react';
import React from 'react';

import { Form } from '@/modules/recognition/presentation/components/Form';
import { ChangePasswordViewModel } from '@/modules/recognition/presentation/screens/AccountManagement/ChangePassword.vm';
import { Button } from '@/shared/presentation/components/ui/Button';
import { Input } from '@/shared/presentation/components/ui/Input';
import { Page } from '@/shared/presentation/components/ui/Page';
import { Space } from '@/shared/presentation/components/ui/Space';

export const ChangePasswordScreen = observer(() => {
  const vm = useViewModel(ChangePasswordViewModel);

  return (
    <Page title="Alterar senha" subtitle="Altere sua senha de acesso ao sistema">
      <Form
        onSubmit={(e) => {
          e.preventDefault();
          vm.update();
        }}
      >
        <Input
          label="Senha atual"
          type="password"
          name="currentPassword"
          errorMessage={vm.form.errors.currentPassword && vm.form.errors.currentPassword[0]}
          onChange={(value) => vm.form.setValue('currentPassword', value)}
          onBlur={() => vm.form.validateField('currentPassword')}
        />

        <Space height={16} />

        <Input
          label="Nova senha"
          type="password"
          name="newPassword"
          errorMessage={vm.form.errors.newPassword && vm.form.errors.newPassword[0]}
          onChange={(value) => vm.form.setValue('newPassword', value)}
          onBlur={() => vm.form.validateField('newPassword')}
        />

        <Space height={16} />

        <Input
          label="Confirmar senha"
          type="password"
          name="newPasswordConfirmation"
          errorMessage={
            vm.form.errors.newPasswordConfirmation && vm.form.errors.newPasswordConfirmation[0]
          }
          onChange={(value) => vm.form.setValue('newPasswordConfirmation', value)}
          onBlur={() => vm.form.validateField('newPasswordConfirmation')}
        />

        <Space height={32} />

        <Button
          type="submit"
          disabled={!vm.form.isValid || vm.isSubmitting}
          variant="primary"
          loading={vm.isSubmitting}
        >
          Salvar
        </Button>
      </Form>
    </Page>
  );
});
